import React, { Component } from "react";
import moment from "moment";
import AdmissionApi from "../../../Services/AdmissionApi";
import Paging from "../../Paging";
import AdDemoImg from '../../../assets/images/ad-demo.png'

class LiveAdvertisement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allCategories: [],
      ads: [],
      selectedAd: '',
      page: 1,
      pageSize: 10,
      totalPages: 1
    }

    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    this.getAllCategories()
  }

  cbCourseCategories = (newResponse) => {
    if (newResponse.data.success) {
      const _categories = newResponse.data._embedded.category

      const allCategories = _categories.map(item => ({
        label: item.name,
        value: item.id,
      }))

      this.setState({ allCategories }, this.getData);
    }
  }
  
  getAllCategories = () => {
    this.admissionsService.GetData(
      this.cbCourseCategories,
      "v1/students/alert/category"
    )
  }

  updateState = (response) => {
    this.setState({
      ads: response.data._embedded.Advertisements,
      page: response.data.page,
      totalPages: response.data.pageCount
    })
  }

  getData = (page = 1) => {
    const {
      selectedAd,
      pageSize
    } = this.state

    let formData = new FormData()
    formData.append('sortParam', 'createdAt')
    formData.append('sortBy', 'desc')
    formData.append('perPage', pageSize)
    formData.append('filterByLiveAdv', '1')
    formData.append('filterByCount', '1')

    this.admissionsService.getAds(
      this.updateState,
      `v1/advertisement/list?page=${page}`,
      formData
    )
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = (e) => {
    e.preventDefault()
    this.getData()
  }

  clearFilter = () => {
    this.setState({
      selectedAd: ''
    }, this.getData)
  }

  handlePageChange = (page) => {
    this.getData(page)
  }

  render() {
    const {
      ads,
      page,
      totalPages,
      selectedAd,
      allCategories
    } = this.state
    const { showDetails, updateRoutePage } = this.props

    return (
      <section className="dash-alerts">
        {/* <form>
          <div className="alert-filter">
            <input
              id="selectedAd"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="User Name"
              value={selectedAd}
              onChange={this.handleFilterInputChange}
            />
            <button type="submit" onClick={this.filterList} className="btn btn--primary">
              Submit
            </button>
            <button type="button" onClick={this.clearFilter} className="btn btn--default ml-2">
              Clear
            </button>
          </div>
        </form> */}
        <table className="table table-responsive alert-table">
          <thead>
            <tr>
              <th scope="col">Ad</th>
              <th scope="col">University</th>
              <th scope="col">Course Category</th>
              <th scope="col">Total Clicks</th>
              <th scope="col">Live Until</th>
            </tr>
          </thead>
          <tbody>
            {ads.map(item => (
              <tr key={item.id}>
                <td>
                  <img className="career-img" src={item.fileUrl} alt="Ad1" />
                </td>
                <td>{item.university.name}</td>
                <td>{item.advertisementCategory.map(item => allCategories.find(cat => cat.value == item.categoryId).label).join(', ')}</td>
                <td>{item.totalClickCount}</td>
                <td>{moment(item.liveUntil).format('DD/MM/YYYY')}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Paging
          page={page}
          totalPages={totalPages}
          onChange={this.handlePageChange}
        />
      </section>
    )
  }
}

export default LiveAdvertisement



/** WEBPACK FOOTER **
 ** ./src/components/Admin/LiveAdvertisement/index.js
 **/